/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractResourceService, JsonApiResource } from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import { TermsAndConditionsDtoModel, TermsAndConditionsTypeEnum } from '@well/domain';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsResourceService extends AbstractResourceService<
  any,
  TermsAndConditionsDtoModel,
  any,
  any
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('termsAndConditionsUrl'),
      undefined,
      TermsAndConditionsDtoModel
    );
  }

  findByDocumentTypeAndLastVersion(
    documentType: TermsAndConditionsTypeEnum
  ): Observable<JsonApiResource<TermsAndConditionsDtoModel, null>> {
    return this.httpClient?.get(`${this.url}/${documentType}`).pipe(this.getDtoMapper());
  }

  getUnacceptedLatestForUserOrEmail(userUuid: string, documentType: TermsAndConditionsTypeEnum) {
    return this.httpClient?.get(`${this.url}/user/${userUuid}/${documentType}`).pipe(this.getDtoMapper()) as Observable<
      JsonApiResource<TermsAndConditionsDtoModel, null>
    >;
  }
}
